import React from 'react'
import PropTypes from 'prop-types'
import { Modal, Button } from '@resurs/midas-react'

import { getText } from '../../../internal/TextLabels'

const DeleteUserModal = ({ onClose, onDeleteUser }) => (
  <Modal
    show
    hideClose
    title={getText('user.delete.title')}
    onClose={() => onClose()}
    actions={
      <Button type="link" onClick={() => onClose()}>
        {getText('default.close')}
      </Button>
    }
  >
    <div style={{ display: 'block', margin: '0 auto', textAlign: 'center' }}>
      <strong>{getText('user.delete.confirmQuestion')}</strong>
      <div>{getText('user.delete.confirmDesc')}</div>
    </div>
    <div
      style={{
        display: 'block',
        margin: '0 auto',
        textAlign: 'center',
        paddingTop: '2rem',
      }}
    >
      <Button
        text={getText('user.delete.button')}
        type="primary"
        kind="danger"
        onClick={e => {
          e.preventDefault()
          onClose()
          onDeleteUser()
        }}
      />
    </div>
  </Modal>
)

DeleteUserModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onDeleteUser: PropTypes.func.isRequired,
}

export default DeleteUserModal
